<template>
    <g-base-box class="network-marketplace-invitation-box margin-bottom-large">
        <template v-if="inviteLink">
            <g-level>
                <g-level-item>
                    <div>
                        <g-typography tag="span" font-weight="semibold">
                            Remember to use your
                            {{ getNetworkMarketplaceLabel(networkId) }} invite link:
                            <a :href="inviteLink" target="_blank" class="invite-link g-color-primary g-font-normal">
                                {{ inviteLink }}
                            </a>
                        </g-typography>
                    </div>
                </g-level-item>
                <template #right>
                    <g-level-item>
                        <g-copy-button
                            icon="copy"
                            :minimalist="true"
                            :copy-text="inviteLink"
                            class="invite-link-copy-button"
                        />
                    </g-level-item>
                </template>
            </g-level>
        </template>
        <template v-else>
            <!-- Creator licensing configs fallback -->
            <g-typography v-for="config in creatorLicensingConfigs" :key="config.id" tag="span" font-weight="semibold">
                {{ getFallbackMessage(config.network_id) }}
            </g-typography>

            <!-- TTOCM campaign fallback (when no creator licensing configs but component is still shown) -->
            <g-typography v-if="!creatorLicensingConfigs.length" tag="span" font-weight="semibold">
                {{ getFallbackMessage(tiktokId) }}
            </g-typography>
        </template>
    </g-base-box>
</template>

<script>
    import { computed, defineComponent, toRefs } from 'vue-demi';
    import { NETWORK_MARKETPLACE_NAMES, TIKTOK_ID } from '../../../../constants/networks';

    export default defineComponent({
        name: 'NetworkMarketplaceInvitationBox',
        props: {
            creatorLicensingConfigs: {
                type: Array,
                default: () => []
            },
            contentRequests: {
                type: Object, // This is a single item
                default: () => {}
            },
            latestTtocmCampaignHistory: {
                type: Object,
                default: () => {}
            }
        },
        setup(props) {
            const { contentRequests, latestTtocmCampaignHistory } = toRefs(props);

            const inviteLink = computed(() => {
                // Prioritize content requests (creator licensing)
                if (contentRequests.value?.invite_link) {
                    return contentRequests.value.invite_link;
                }

                // Fallback to TTOCM campaign history
                if (latestTtocmCampaignHistory.value?.invite_link) {
                    return latestTtocmCampaignHistory.value.invite_link;
                }

                return null;
            });

            const networkId = computed(() => {
                // Use content requests network ID if available
                if (contentRequests.value?.network_id) {
                    return contentRequests.value.network_id;
                }

                // Default to TikTok ID for TTOCM campaigns
                return TIKTOK_ID;
            });

            const getNetworkMarketplaceLabel = (networkId) => {
                return NETWORK_MARKETPLACE_NAMES[networkId] ?? '';
            };

            const getFallbackMessage = (networkId) => {
                return `Your ${getNetworkMarketplaceLabel(
                    networkId
                )} invite link will be created after your proposal is accepted.`;
            };

            const tiktokId = TIKTOK_ID;

            return {
                inviteLink,
                networkId,
                TIKTOK_ID,
                getNetworkMarketplaceLabel,
                getFallbackMessage,
                tiktokId
            };
        }
    });
</script>

<style lang="scss" scoped>
    .network-marketplace-invitation-box {
        background-color: #f9fafb;
    }

    .invite-link-copy-button {
        color: $g-color-primary;
    }
</style>
